<template>
    <a-config-provider :locale="locale">
        <a-layout style="min-height: 100vh;">
            <a-layout-header :style="{ background: 'none', height: 'inherit', padding: 0, }">
                <a-menu mode="horizontal" :active-key="($route.name as string)" theme="dark"
                    :style="{ justifyContent: 'center', alignItems: 'center' }" :selected-keys="[]">
                    <a-menu-item key="logo">
                        <router-link :to="{ name: RouteName.TOP }"><img src="/logo.png?v=1" alt="logo"
                                style="height: 80px; " /></router-link>
                    </a-menu-item>
                    <a-menu-item key="home">
                        <a :href="getHomeUrl()">{{ $t('text.home') }}</a>
                    </a-menu-item>
                    <template v-if="isLoggedIn">
                        <a-sub-menu>
                            <template #icon>
                                <UserOutlined />
                            </template>
                            <template #title>{{ authUser.name }}</template>

                            <a-menu-item @click="onLogout">
                                <template #icon>
                                    <LogoutOutlined />
                                </template>
                                <span>{{ $t('text.logout') }}</span>
                            </a-menu-item>
                        </a-sub-menu>
                    </template>
                    <template v-else>
                        <a-menu-item :key="RouteName.LOGIN">
                            <router-link :to="{ name: RouteName.LOGIN }">{{ $t('text.login') }}</router-link>
                        </a-menu-item>
                        <a-menu-item :key="RouteName.REGISTER">
                            <router-link :to="{ name: RouteName.REGISTER }">{{ $t('text.register') }}</router-link>
                        </a-menu-item>
                    </template>
                </a-menu>
            </a-layout-header>

            <a-layout-content class="mt-20">
                <router-view />
            </a-layout-content>
        </a-layout>
    </a-config-provider>
</template>

<script lang="ts">
import { computed, defineComponent, } from 'vue'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import {
    ConfigProvider,
    Menu, MenuItem, Layout, LayoutHeader, LayoutContent, Modal,
} from 'ant-design-vue';
import {
    UserOutlined, LogoutOutlined,
} from '@ant-design/icons-vue';
import viVN from 'ant-design-vue/es/locale/vi_VN';

import dayjs from 'dayjs';
import 'dayjs/locale/vi';

import { backToLogin, RouteName, } from '@/router';
import ApiRequest from './utils/ApiRequest';
import { processEnv } from './utils/helpers';

import { storageKey as userStorageKey, StoreType as UserStoreType } from '@/store/modules/user';

export default defineComponent({
    components: {
        AConfigProvider: ConfigProvider,
        AMenu: Menu,
        AMenuItem: MenuItem,
        ASubMenu: Menu.SubMenu,
        ALayout: Layout,
        ALayoutHeader: LayoutHeader,
        ALayoutContent: LayoutContent,

        UserOutlined,
        LogoutOutlined,
    },

    setup() {
        const router = useRouter();
        const store = useStore();
        const authUser = computed(() => store.getters.user);
        const isLoggedIn = computed((): boolean => store.getters.isLoggedIn);
        const { t } = useI18n();

        // TODO: Not Working
        const locale = viVN;

        dayjs.locale('vi');

        router.afterEach((to) => {
            const routeTitleT = (to.meta.title as string);
            const appTitle: string = processEnv.VUE_APP_NAME;
            document.title = routeTitleT ? (t(routeTitleT) + ' | ' + appTitle) : appTitle;
        });

        const onLogout = () => {
            Modal.confirm({
                title: t('message.confirmLogout'),
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.post('/logout')
                        .then(() => {
                            backToLogin();
                        });
                },
            });
        };

        const getHomeUrl = () => {
            const loc = window.location;
            const locHost = loc.host;
            const domain = !locHost.indexOf("localhost:") ? (locHost + ApiRequest.API_BASE_URL + '/fronts') : locHost.split('.').slice(1).join('.');
            return `//${domain}`;
        };

        window.addEventListener('storage', (e) => {
            if (e.key === userStorageKey) {
                if (e.newValue) {
                    // TODO: When at login page -> redirect to home page
                    store.dispatch(UserStoreType.FETCH_USER);
                }
            }
        });

        return {
            locale,

            authUser,
            isLoggedIn,

            onLogout,
            getHomeUrl,

            RouteName,
        };
    },
})
</script>

<style scoped>
</style>
